import classnames from 'classnames';
import collect from 'collect.js';
import { ReactElement } from 'react';

interface Item<T> {
  label: ReactElement | string;
  value: T;
  icon?: ReactElement;
  className?: string;
  activeClassName?: string;
}

interface Props {
  items: Item<any>[];
  value: any;
  className?: string;
  onClick?: (value: any) => void;
}

const TabBar = (props: Props): JSX.Element => {
  const { items, value, onClick, className } = props;

  const _items = collect(items).whereNotNull('value').toArray();

  return (
    <div
      className={classnames('grid grid-cols-2 rounded-full bg-gray-500 dark:bg-black-600 p-xs', className)}
      style={{
        gridTemplateColumns: `repeat(${_items?.length}, minmax(0, 1fr))`,
      }}
    >
      {_items.map((item: Item<any>, index: number) => (
        <div
          className={classnames(
            'px-2xl py-sm justify-center items-center flex rounded-full cursor-pointer z-10',
            item.className,
            {
              'border-[1px] border-brand-primary bg-white dark:bg-black': value === item.value,
              [item?.activeClassName]: value === item.value,
            },
          )}
          onClick={() => onClick(item.value)}
          key={`tab-${item.label}-${index}`}
        >
          {Boolean(item.icon) && <span className="my-auto mr-xs">{item.icon}</span>}
          <h6
            className={classnames('my-auto text-brand-primary shrink-0', {
              '!text-brand-text-secondary': value !== item.value,
            })}
          >
            {item.label}
          </h6>
        </div>
      ))}
    </div>
  );
};

export default TabBar;
